import React, { useEffect, useState } from "react";
import Styles from "./Message.module.css";
import { TiPlusOutline } from "react-icons/ti";
import { CiMail } from "react-icons/ci";
import { HiOutlineMail } from "react-icons/hi";
import { BsSend } from "react-icons/bs";
import { useForm, SubmitHandler } from "react-hook-form";
import { showSuccessAlert, showWarningAlert } from "Utils/Alerts";
import { Send_Message, get_Messages } from "Services/Requests";
import Loader from "Components/Loader/loader";
import Moment from "react-moment";
import { useStore } from "Store";

type Inputs = {
    message: string;
    subject: string;
};
function Messages() {
    const { isDisabled } = useStore((state: any) => state);

    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm<Inputs>();
    const [Active, setActive] = useState("messages");
    const [type, setType] = useState("general_enquiry");
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState([]);
    const getMessages = async () => {
        setLoading(true);
        try {
            const response = await get_Messages();
            setLoading(false);
            if (response.data.Status === 1) {
                setMessages(response?.data?.Messages);
            } else {
                showWarningAlert(
                    response?.data.Message || "Something went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        if (Active != "compose") {
            getMessages();
        }
    }, [Active]);

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        setLoading(true);
        try {
            const response = await Send_Message({
                ...data,
                message_type: type,
            });
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessAlert("Message Send Successfully");
                reset();
            } else {
                showWarningAlert(
                    response?.data.Message || "Something went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };

    return (
        <div className={Styles["Container"]}>
            {loading && <Loader />}

            <h3> New Message</h3>
            <div className={Styles["Messages-wrapper"]}>
                <div className={Styles["Messages-left"]}>
                    {!isDisabled && (
                        <button
                            className={Styles["compose"]}
                            onClick={() => setActive("compose")}>
                            <TiPlusOutline /> Compose
                        </button>
                    )}
                    <div>
                        <button
                            className={Styles["all_Messages"]}
                            onClick={() => setActive("messages")}>
                            <span>
                                {" "}
                                <HiOutlineMail />
                            </span>
                            All Messages
                        </button>
                    </div>
                </div>
                {Active == "compose" ? (
                    <div className={Styles["Messages-right"]}>
                        <h3>
                            <TiPlusOutline /> Compose
                        </h3>
                        <form
                            className={Styles["box"]}
                            onSubmit={handleSubmit(onSubmit)}>
                            <div className={Styles["box_content"]}>
                                <header>
                                    <h3>Message Type:</h3>
                                    <div>
                                        <div className={Styles["custom-radio"]}>
                                            <input
                                                type="radio"
                                                id="radio1"
                                                name="radio"
                                                defaultChecked
                                                className={
                                                    Styles["radio-input"]
                                                }
                                                onChange={() =>
                                                    setType("general_enquiry")
                                                }
                                            />
                                            <label
                                                htmlFor="radio1"
                                                className={
                                                    Styles["radio-label"]
                                                }>
                                                General Enquiry
                                            </label>
                                        </div>
                                        <div className={Styles["custom-radio"]}>
                                            <input
                                                type="radio"
                                                id="radio2"
                                                name="radio"
                                                onChange={() =>
                                                    setType("request")
                                                }
                                                className={
                                                    Styles["radio-input"]
                                                }
                                            />
                                            <label
                                                htmlFor="radio2"
                                                className={
                                                    Styles["radio-label"]
                                                }>
                                                Request
                                            </label>
                                        </div>
                                        <div className={Styles["custom-radio"]}>
                                            <input
                                                type="radio"
                                                id="radio3"
                                                name="radio"
                                                className={
                                                    Styles["radio-input"]
                                                }
                                                onChange={() =>
                                                    setType("escalation")
                                                }
                                            />
                                            <label
                                                htmlFor="radio3"
                                                className={
                                                    Styles["radio-label"]
                                                }>
                                                Escalation
                                            </label>
                                        </div>
                                        <div className={Styles["custom-radio"]}>
                                            <input
                                                type="radio"
                                                id="radio4"
                                                name="radio"
                                                className={
                                                    Styles["radio-input"]
                                                }
                                                onChange={() =>
                                                    setType("others")
                                                }
                                            />
                                            <label
                                                htmlFor="radio4"
                                                className={
                                                    Styles["radio-label"]
                                                }>
                                                Others
                                            </label>
                                        </div>
                                    </div>
                                </header>
                                <div className={Styles["inputs"]}>
                                    <div className={Styles["form_control"]}>
                                        <label htmlFor="">Subject</label>
                                        <input
                                            type="text"
                                            placeholder="Subject"
                                            {...register("subject", {
                                                required: true,
                                            })}
                                        />
                                        {errors.subject && (
                                            <span>This field is required</span>
                                        )}
                                    </div>
                                    <div className={Styles["form_control"]}>
                                        <label htmlFor="">Message</label>
                                        <textarea
                                            placeholder="Click here to compose body"
                                            rows={7}
                                            {...register("message", {
                                                required: true,
                                            })}
                                        />
                                        {errors.message && (
                                            <span>This field is required</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button type="submit">
                                {" "}
                                <BsSend />
                                Send
                            </button>
                        </form>
                    </div>
                ) : (
                    <div className={Styles["old_messages"]}>
                        <h2>Messages</h2>
                        <div className={Styles["old_msg_wrapper"]}>
                            {/*  <p style={{ textAlign: "center" }}>
                                No Messages Found
                            </p> */}
                            {/* {Array.from} */}
                            {messages.map((message: any) => (
                                <div className={Styles["message_one"]}>
                                    <h3>
                                        {message.subject}
                                        <span>
                                            <Moment format="DD MMM hh:mm a">
                                                {message?.date}
                                            </Moment>
                                        </span>
                                    </h3>
                                    <p>{message?.message}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Messages;
